const updates = [
  {
    id: 1,
    date: '08.01',
    title: '《死侍与金刚狼》',
    desc: '漫威年度超级英雄巨制高清上线，不缓冲流畅放映',
    tag: '最新上架',
  },
  {
    id: 2,
    date: '07.30',
    title: '暑期档专题页面上线',
    desc: '集结50部暑期热门大片，一页畅览不卡顿播放体验',
    tag: '专题',
  },
  {
    id: 3,
    date: '07.28',
    title: '《疯狂的麦克斯：狂暴女神》',
    desc: '废土美学巅峰之作高清片源上线，极速加载即点即播',
    tag: '高清上线',
  },
  {
    id: 4,
    date: '07.25',
    title: '播放引擎全面升级',
    desc: '秒开技术再优化，全网加载速度提升30%，更流畅',
    tag: '系统升级',
  },
  {
    id: 5,
    date: '07.22',
    title: '《猩球崛起：新世界》',
    desc: '视效大片高清上线，智能预加载技术保障无卡顿观影',
    tag: '特效大片',
  },
  {
    id: 6,
    date: '07.20',
    title: '经典修复专题第二季',
    desc: '20部影史经典4K修复版集体上线，致敬电影艺术',
    tag: '经典修复',
  },
  {
    id: 7,
    date: '07.18',
    title: '移动端观影体验优化',
    desc: '手机播放流畅度大幅提升，通勤追片更省流量',
    tag: '体验升级',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            最新上架
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            每日更新片源动态，不错过任何一部好电影
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-300/40 space-y-8 ml-2">
            {updates.map((item) => (
              <div key={item.id} className="relative group">
                <div className="absolute -left-[calc(2rem+5px)] top-1 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100 group-hover:scale-125 transition-transform duration-200"></div>
                <div className="bg-background-200/50 rounded-lg p-4 md:p-5 border border-background-300/30 hover:border-primary-500/20 transition-colors duration-200">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-xs font-bold text-primary-500 font-heading bg-primary-500/10 px-2 py-0.5 rounded whitespace-nowrap">
                      {item.date}
                    </span>
                    <span className="text-xs text-foreground-600 bg-background-300/40 px-2 py-0.5 rounded whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-200 mb-1">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}